export const Theme = {
  primaryColor: "#fed700",
  primaryColorRgb: "81, 104, 143",
  primaryColorContrast: "#333e48",
  primaryColorContrastRgb: "255, 255, 255",
  primaryColorShade: "#fed700",
  primaryColorTint: "#e9c602",
  secondaryColor: "#fed700",
  secondaryColorRgb: "81, 104, 143",
  secondaryColorContrast: "#333e48",
  secondaryColorContrastRgb: "255, 255, 255",
  secondaryColorShade: "#fed700",
  secondaryColorTint: "#e9c602",
  ternaryColor: "#333e48",
  ternaryColorContrast: "#ffffff",
  toolbarColor: "#333e48",
  toolbarBackgroundColor: "#fed700",
  toolbarBackgroundColorConstrast: "#333e48",
  homePageCategorySize: "80px",
  categoryIconPadding: "10px 10px 0 10px",
  categoryIconSize: "auto",
  categoryCardBR: "unset",
  categoryCardImageBR: "0.5rem",
  cartProductBR: "8px",
  cartProductImageBR: "unset",

  headerLogoWidthMinimized: "100px",
  headerLogoHeightMinimized: "40px",
  headerLogoWidth: "120px",
  borderRadiusValue: "25px",
  borderRadiusProductValue: "20px",
  colorSectionsValue: "#333e48",

  colorNewProduct: "#f53d3d",
  transformScaleValueCategory: null,
  transformScaleValue: "none",
  borderRadiusButtonValue: "10px",
  borderRadiusInputValue: "22px",
  borderRadiusToolbarValue: "0px 0px 12px 12px",
  borderRadiusCardValue: "12px",
  borderShadowNewListProduct: "none",
  borderRadiusNewListValue: "0",
  cardBorderValue: "1px solid transparent",
  borderProductNewListBottom: "1px solid rgba(169, 165, 153, 0.15)",

  dangerColor: "#f53d3d",
  dangerColorRgb: "245, 61, 61",
  dangerColorContrast: "#ffffff",
  dangerColorContrastRgb: "255, 255, 255",
  dangerColorShade: "#d83636",
  dangerColorTint: "#f65050",

  lightColor: "#fafafa",
  lightColorShade: "#dcdcdc",
  lightColorContrast: "#000",
  lightColorTint: "#fbfbfb",
  lightColorRgb: "244, 244, 244",
  lightColorContrastRgb: "0, 0, 0",

  mediumColor: "#989aa2",
  mediumColorShade: "#86888f",
  mediumColorRgb: "152, 154, 162",
  mediumColorContrast: "#fff",
  mediumColorTint: "#a2a4ab",
  mediumColorContrastRgb: "255, 255, 255",

  successColor: "rgb(61, 179, 61)",
  successColorRgb: "16, 220, 96",
  successColorContrast: "#ffffff",
  successColorContrastRgb: "255, 255, 255",
  successColorShade: "#0ec254",
  successColorTint: "#28e070",

  darkColor: "#212121",
  darkColorRgb: "34, 34, 34",
  darkColorContrast: "#ffffff",
  darkColorContrastRgb: "255, 255, 255",
  darkColorShade: "#1d1d1d",
  darkColorTint: "#373737",

  warningColor: "#ffce00",
  warningColorRgb: "255, 206, 0",
  warningColorContrast: "#ffffff",
  warningColorContrastRgb: "255, 255, 255",
  warningColorShade: "#e0b500",
  warningColorTint: "#ffd31a",

  searchMainCategoriesSubtitleColor: "#3f3f3f",
  homePageCategorySlidePadding: "0 5px",
  homePageCategorySlideShadow: "none",
  imageBackgroundColor: "unset",
  sliderItemMarginRight: "5px",
  swiperNavigationSize: "1.125rem",

  storiesBorderReadColor: "rgba(31, 77, 111, 0.2)",
  storiesGap: "8px",
  storiesHeight: "105px",
  storiesListSidePadding: "0px",
  storiesListBottomMargin: "0px",
  storiesListBorderReadWidth: "2px",
  storiesListBorderGapRead: "3px",
  storiesListBorderRadiusRead: "18px",
  storiesListControlsSize: "48px",
  storiesListControlsBackgroundColor: "transparent",
  storiesListControlsColor: "black",
  storiesListInnerBorderRadiusNotRead: "15px",
  storiesListInnerBorderRadiusRead: "14px",

  storiesListItemTitlePadding: "6px",
  storiesListItemTitleFont: "12px/14px InternalPrimaryFont",
  storiesListItemTitleFontFamily: "InternalPrimaryFont",
  storiesListItemTitleColor: "white",
  storiesListBorderRadius: "18px",
  storiesListBorderGapNotRead: "2px",
  storiesListBorderNotReadWidth: "2px",
  storiesBorderNotReadColor: "#d8d8d8",
  storiesListBorderRadiusImage: "15px",

  collectionShowAllBGColor: "#E9E9E9",
  collectionShowAllTextColor: "#888888",
  collectionsRadius: "9px",
  collectionBGColor: "#D9D9D9",
  collectionsSize: "100px",
  collectionSize: "49px",
  heightBottomTabs: "0",

  productSliderCardWidth: "105px !important",
  productSliderCardMinWidth: "105px !important",
  productSliderCardMaxWidth: "105px !important",
};
